/* eslint-disable react/no-unknown-property */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { change_test_screen } from '../../../redux/action';
import style from '../../../assets/styles/sidebarStyle.module.css';

const SideBarMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [activeSubMenu, setActiveSubMenu] = useState('');

  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const Roles = userInfo.roles || [];
  const isOrganizationAdmin = Roles.some((role: { id: number; name: string }) => role.id === 9);
  const isOrganizationUser = Roles.some((role: { id: number; name: string }) => role.id === 10);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubMenuClick = (submenu: string) => {
    setActiveSubMenu(submenu); // Update the active submenu item without closing the menu
  };

  const isImportManagerActive =
    location.pathname.startsWith('/document-logger') || location.pathname.startsWith('/import-questions');
  const activePaths = ['/document-logger', '/import-questions', '/question-bank'];
  const isQuestionBankActive = activePaths.some((path) => location.pathname.startsWith(path));
  const isMangementActive =
    [
      '/user-management',
      '/organization-management',
      '/organization-management/add',
      '/masters',
      '/add-new-pipeline',
    ].includes(location.pathname) ||
    location.pathname.startsWith('/edit-subject-pipeline') ||
    location.pathname.startsWith('/organization-management/edit') ||
    location.pathname.startsWith('/organization-management/details');

  const isMgtActive = location.pathname === '/add-new-pipeline';
  const isEditSubjectPipeLine = location.pathname.startsWith('/edit-subject-pipeline');
  const isCreateQuestion =
    location.pathname.startsWith('/create-question') || location.pathname.startsWith('/edit-question');
  const isReportActive = location.pathname === '/reports-history';
  const isViewReportDetailsActive = location.pathname.startsWith('/view-distribution-report-detail');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkIsActive = (match: any) => {
    if (!location) return undefined;
    return location?.pathname === match ? '#00ABFB' : '#272727';
  };

  const strokeColor = isQuestionBankActive ? '#00ABFB' : '#272727';
  const svgPaths = [
    {
      d: 'M21 7.94141V17.9414C21 20.9414 19.5 22.9414 16 22.9414H8C4.5 22.9414 3 20.9414 3 17.9414V7.94141C3 4.94141 4.5 2.94141 8 2.94141H16C19.5 2.94141 21 4.94141 21 7.94141Z',
    },
    {
      d: 'M8 17.5391H16',
    },
    {
      d: 'M8 13.5391H12',
    },
    {
      d: 'M15 5.33984V7.13984C15 8.12984 15.81 8.93984 16.8 8.93984H18.6',
    },
  ];

  const strokeColorTwo = checkIsActive('/test-papers-management');

  const paths = [
    {
      d: 'M21.6602 11.3799L20.6802 15.5599C19.8402 19.1699 18.1802 20.6299 15.0602 20.3299C14.5602 20.2899 14.0202 20.1999 13.4402 20.0599L11.7602 19.6599C7.59018 18.6699 6.30018 16.6099 7.28018 12.4299L8.26018 8.23995C8.46018 7.38995 8.70018 6.64995 9.00018 6.03995C10.1702 3.61995 12.1602 2.96995 15.5002 3.75995L17.1702 4.14995C21.3602 5.12995 22.6402 7.19995 21.6602 11.3799Z',
    },
    {
      d: 'M15.0603 20.333C14.4403 20.753 13.6603 21.103 12.7103 21.413L11.1303 21.933C7.16034 23.213 5.07034 22.143 3.78034 18.173L2.50034 14.223C1.22034 10.253 2.28034 8.15297 6.25034 6.87297L7.83034 6.35297C8.24034 6.22297 8.63034 6.11297 9.00034 6.04297C8.70034 6.65297 8.46034 7.39297 8.26034 8.24297L7.28034 12.433C6.30034 16.613 7.59034 18.673 11.7603 19.663L13.4403 20.063C14.0203 20.203 14.5603 20.293 15.0603 20.333Z',
    },
    {
      d: 'M11.6602 13.3398L14.5602 14.0798',
    },
    {
      d: 'M12.6406 9.47266L17.4906 10.7027',
    },
  ];

  const pathsreport = [
    'M2.28027 22.9427C2.28027 22.545 2.60263 22.2227 3.00027 22.2227H21.0003C21.3979 22.2227 21.7203 22.545 21.7203 22.9427C21.7203 23.3403 21.3979 23.6627 21.0003 23.6627H3.00027C2.60263 23.6627 2.28027 23.3403 2.28027 22.9427Z',
    'M2.28027 10.3216C2.28027 9.37392 3.05263 8.60156 4.00027 8.60156H5.60025C6.54789 8.60156 7.32025 9.37392 7.32025 10.3216V18.9416C7.32025 19.8892 6.54789 20.6616 5.60025 20.6616H4.00027C3.05263 20.6616 2.28027 19.8892 2.28027 18.9416V10.3216ZM4.00027 10.0416C3.84792 10.0416 3.72027 10.1692 3.72027 10.3216V18.9416C3.72027 19.0939 3.84792 19.2216 4.00027 19.2216H5.60025C5.7526 19.2216 5.88025 19.0939 5.88025 18.9416V10.3216C5.88025 10.1692 5.7526 10.0416 5.60025 10.0416H4.00027Z',
    'M9.47949 7.13406C9.47949 6.18642 10.2518 5.41406 11.1995 5.41406H12.7995C13.7471 5.41406 14.5195 6.18642 14.5195 7.13406V18.9441C14.5195 19.8917 13.7471 20.6641 12.7995 20.6641H11.1995C10.2518 20.6641 9.47949 19.8917 9.47949 18.9441V7.13406ZM11.1995 6.85406C11.0471 6.85406 10.9195 6.98171 10.9195 7.13406V18.9441C10.9195 19.0964 11.0471 19.2241 11.1995 19.2241H12.7995C12.9518 19.2241 13.0795 19.0964 13.0795 18.9441V7.13406C13.0795 6.98171 12.9518 6.85406 12.7995 6.85406H11.1995Z',
    'M16.6807 3.94266C16.6807 2.99501 17.453 2.22266 18.4007 2.22266H20.0006C20.9483 2.22266 21.7206 2.99501 21.7206 3.94266V18.9427C21.7206 19.8903 20.9483 20.6627 20.0006 20.6627H18.4007C17.453 20.6627 16.6807 19.8903 16.6807 18.9427V3.94266ZM18.4007 3.66266C18.2483 3.66266 18.1207 3.7903 18.1207 3.94266V18.9427C18.1207 19.095 18.2483 19.2227 18.4007 19.2227H20.0006C20.153 19.2227 20.2806 19.095 20.2806 18.9427V3.94266C20.2806 3.7903 20.153 3.66266 20.0006 3.66266H18.4007Z',
  ];
  const iconColor = isReportActive || isViewReportDetailsActive ? '#00ABFB' : '#272727';

  const svgPathReview = [
    {
      d: 'M1 7.06726C1 4.22304 3.36051 1.94141 6.22658 1.94141H15.3334C18.1983 1.94141 20.56 4.21195 20.56 7.06726V14.0186C20.56 14.4494 20.2108 14.7986 19.78 14.7986C19.3492 14.7986 19 14.4494 19 14.0186V7.06726C19 5.10931 17.373 3.50141 15.3334 3.50141H6.22658C4.18818 3.50141 2.56 5.11811 2.56 7.06726V18.1755C2.56 20.1335 4.18701 21.7414 6.22658 21.7414H13.7359C14.1667 21.7414 14.5159 22.0906 14.5159 22.5214C14.5159 22.9522 14.1667 23.3014 13.7359 23.3014H6.22658C3.36169 23.3014 1 21.0309 1 18.1755V7.06726Z',
      fill: checkIsActive('/review'),
    },
    {
      d: 'M18.2446 17.0103C17.0419 17.0103 16.067 17.9853 16.067 19.1879C16.067 20.3906 17.0419 21.3656 18.2446 21.3656C19.4473 21.3656 20.4222 20.3906 20.4222 19.1879C20.4222 17.9853 19.4473 17.0103 18.2446 17.0103ZM14.627 19.1879C14.627 17.19 16.2466 15.5703 18.2446 15.5703C20.2425 15.5703 21.8622 17.19 21.8622 19.1879C21.8622 21.1859 20.2426 22.8056 18.2446 22.8056C16.2466 22.8056 14.627 21.1859 14.627 19.1879Z',
      fill: checkIsActive('/review'),
    },
    {
      d: 'M20.229 20.8675C20.4927 20.5699 20.9478 20.5424 21.2454 20.8061L22.9273 22.2966C23.2249 22.5603 23.2524 23.0154 22.9887 23.313C22.725 23.6106 22.2699 23.6381 21.9723 23.3743L20.2903 21.8839C19.9927 21.6202 19.9653 21.1651 20.229 20.8675Z',
      fill: checkIsActive('/review'),
    },
    {
      d: 'M4.47363 8.91531C4.47363 8.51767 4.79599 8.19531 5.19363 8.19531H11.4385C11.8362 8.19531 12.1585 8.51767 12.1585 8.91531C12.1585 9.31296 11.8362 9.63531 11.4385 9.63531H5.19363C4.79599 9.63531 4.47363 9.31296 4.47363 8.91531Z',
      fill: checkIsActive('/review'),
    },
    {
      d: 'M4.47363 12.4544C4.47363 12.0567 4.79599 11.7344 5.19363 11.7344H8.31608C8.71373 11.7344 9.03608 12.0567 9.03608 12.4544C9.03608 12.852 8.71373 13.1744 8.31608 13.1744H5.19363C4.79599 13.1744 4.47363 12.852 4.47363 12.4544Z',
      fill: checkIsActive('/review'),
    },
  ];

  const pathsTaskMgt = [
    'M11.6191 9.80819C11.6191 9.39204 11.9565 9.05469 12.3726 9.05469H17.6472C18.0633 9.05469 18.4007 9.39204 18.4007 9.80819C18.4007 10.2243 18.0633 10.5617 17.6472 10.5617H12.3726C11.9565 10.5617 11.6191 10.2243 11.6191 9.80819Z',
    'M9.9009 7.76757C10.1952 8.06183 10.1952 8.53892 9.9009 8.83318L7.6404 11.0937C7.34614 11.388 6.86904 11.388 6.57478 11.0937L5.82128 10.3402C5.52702 10.0459 5.52702 9.56884 5.82128 9.27457C6.11554 8.98031 6.59263 8.98031 6.88689 9.27457L7.10759 9.49527L8.83529 7.76757C9.12955 7.47331 9.60664 7.47331 9.9009 7.76757Z',
    'M11.6191 16.8394C11.6191 16.4233 11.9565 16.0859 12.3726 16.0859H17.6472C18.0633 16.0859 18.4007 16.4233 18.4007 16.8394C18.4007 17.2556 18.0633 17.5929 17.6472 17.5929H12.3726C11.9565 17.5929 11.6191 17.2556 11.6191 16.8394Z',
    'M9.9009 14.7988C10.1952 15.0931 10.1952 15.5702 9.9009 15.8644L7.6404 18.1249C7.34614 18.4192 6.86904 18.4192 6.57478 18.1249L5.82128 17.3714C5.52702 17.0772 5.52702 16.6001 5.82128 16.3058C6.11554 16.0116 6.59263 16.0116 6.88689 16.3058L7.10759 16.5265L8.83529 14.7988C9.12955 14.5046 9.60664 14.5046 9.9009 14.7988Z',
    'M3.05348 3.99391C4.39418 2.65321 6.40039 2.14062 8.98638 2.14062H15.0144C17.6004 2.14062 19.6066 2.65321 20.9473 3.99391C22.288 5.33461 22.8006 7.34082 22.8006 9.92681V15.9548C22.8006 18.5408 22.288 20.547 20.9473 21.8877C19.6066 23.2284 17.6004 23.741 15.0144 23.741H8.98638C6.40039 23.741 4.39418 23.2284 3.05348 21.8877C1.71278 20.547 1.2002 18.5408 1.2002 15.9548V9.92681C1.2002 7.34082 1.71278 5.33461 3.05348 3.99391ZM4.11909 5.05952C3.19929 5.97933 2.7072 7.48946 2.7072 9.92681V15.9548C2.7072 18.3922 3.19929 19.9023 4.11909 20.8221C5.0389 21.7419 6.54903 22.234 8.98638 22.234H15.0144C17.4518 22.234 18.9619 21.7419 19.8817 20.8221C20.8015 19.9023 21.2936 18.3922 21.2936 15.9548V9.92681C21.2936 7.48946 20.8015 5.97933 19.8817 5.05952C18.9619 4.13971 17.4518 3.64763 15.0144 3.64763H8.98638C6.54903 3.64763 5.0389 4.13971 4.11909 5.05952Z',
  ];

  const renderPath = (d: string) => (
    <path fillRule="evenodd" clipRule="evenodd" d={d} fill={checkIsActive('/task-management')} />
  );

  return (
    <div className={style.menus}>
      {/* ________ MAIN MENU ITEMS OF SIDEBAR ________ */}
      <ul className={` ${style.main_menus} ${style.main_menus_top}`}>
        <li>
          {/* Main Menu */}
          <div
            className={`${style.menu_item_content} ${
              ['/question-bank', '/document-logger', '/create-question', '/import-questions'].includes(
                location.pathname
              )
                ? style.active
                : ''
            }`}
          >
            <div className={style.menu_item}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  {svgPaths.map((path, index) => (
                    <path
                      key={index + path.d}
                      d={path.d}
                      stroke={strokeColor}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  ))}
                </g>
              </svg>
              <span className={style.menu_name}>Question Bank</span>
            </div>
          </div>
          {/* ________ SUB MENU ITEMS OF SIDEBAR ________ */}
          <ul className={style.sub_menu}>
            <li>
              <NavLink
                to="/question-bank"
                className={({ isActive }) => {
                  const isActiveClass = isActive || activeSubMenu === 'question-bank' || isCreateQuestion;
                  const activeClass = isActiveClass ? `${style.active} ${style.additionalActiveClass}` : '';
                  return `${style.sub_menu_item} ${activeClass}`;
                }}
                onClick={() => handleSubMenuClick('question-bank')}
              >
                Question Listing
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/document-logger"
                className={({ isActive }) =>
                  `${style.sub_menu_item} ${
                    isActive || isImportManagerActive || activeSubMenu === 'document-logger'
                      ? `${style.active} ${style.additionalActiveClass}`
                      : ''
                  }`
                }
                onClick={() => handleSubMenuClick('document-logger')}
              >
                Question Import Manager
              </NavLink>
            </li>
          </ul>
        </li>

        <li>
          <NavLink
            to="/test-papers-management"
            className={({ isActive }) => `${style.menu_item_content} ${isActive ? style.active : ''}`}
            onClick={() => dispatch(change_test_screen(0))}
          >
            <div className={style.menu_item}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  {paths.map((path, index) => (
                    <path
                      key={+path.d}
                      d={path.d}
                      stroke={strokeColorTwo}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  ))}
                </g>
              </svg>
              <span className={style.menu_name}>Test Papers</span>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/task-management"
            className={({ isActive }) => `${style.menu_item_content} ${isActive ? style.active : ''}`}
          >
            <div>
              <div className={style.menu_item}>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7">{pathsTaskMgt.map((d) => renderPath(d))}</g>
                </svg>

                <span className={style.menu_name}> Task Management</span>
              </div>
            </div>
          </NavLink>
        </li>
        {!isOrganizationUser && (
          <li>
            <NavLink
              to="/user-management"
              className={({ isActive }) =>
                `${style.menu_item_content} ${isActive || isMangementActive ? style.active : ''}`
              }
              onClick={() => dispatch(change_test_screen(0))}
            >
              <div className={style.menu_item}>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    // stroke={isMangementActive?"#00ABFB":"#272727"}
                    strokeWidth="1"
                    clipRule="evenodd"
                    d="M11 8.69141C9.75736 8.69141 8.75 9.69877 8.75 10.9414C8.75 12.184 9.75736 13.1914 11 13.1914C12.2426 13.1914 13.25 12.184 13.25 10.9414C13.25 9.69877 12.2426 8.69141 11 8.69141ZM7.25 10.9414C7.25 8.87034 8.92893 7.19141 11 7.19141C13.0711 7.19141 14.75 8.87034 14.75 10.9414C14.75 13.0125 13.0711 14.6914 11 14.6914C8.92893 14.6914 7.25 13.0125 7.25 10.9414Z"
                    fill={isMangementActive ? '#00ABFB' : '#272727'}
                  />
                  <path
                    fillRule="evenodd"
                    // stroke={isMangementActive?"#00ABFB":"#272727"}
                    strokeWidth="1"
                    clipRule="evenodd"
                    d="M8.60347 2.71171C8.3358 2.26576 7.77209 2.12704 7.35347 2.37609L7.34256 2.38258L5.61251 3.37249C5.06514 3.68527 4.8763 4.39442 5.1894 4.93633L4.54 5.31154L5.18888 4.93544C5.72394 5.85857 5.86779 6.87035 5.38982 7.69976C4.91192 8.52906 3.96479 8.91154 2.9 8.91154C2.26678 8.91154 1.75 9.43318 1.75 10.0615V11.8215C1.75 12.4499 2.26678 12.9715 2.9 12.9715C3.96479 12.9715 4.91192 13.354 5.38982 14.1833C5.86773 15.0126 5.72398 16.0242 5.18909 16.9473C4.87642 17.4891 5.06491 18.1977 5.6121 18.5104L7.35352 19.5069C7.77214 19.7559 8.33577 19.6173 8.60345 19.1714L8.71093 18.9858C9.2458 18.063 10.052 17.434 11.0087 17.434C11.9662 17.434 12.7699 18.0634 13.3 18.9873C13.3002 18.9877 13.3004 18.9881 13.3007 18.9885L13.4065 19.1714C13.6742 19.6173 14.2379 19.756 14.6565 19.507L14.6674 19.5005L16.3975 18.5106C16.9434 18.1986 17.1351 17.4993 16.8198 16.9453C16.2858 16.0228 16.1426 15.012 16.6202 14.1833C17.0981 13.354 18.0452 12.9715 19.11 12.9715C19.7432 12.9715 20.26 12.4499 20.26 11.8215V10.0615C20.26 9.42832 19.7384 8.91154 19.11 8.91154C18.0452 8.91154 17.0981 8.52906 16.6202 7.69976C16.1423 6.87051 16.286 5.85896 16.8208 4.93598C17.1336 4.39411 16.9451 3.68544 16.3979 3.37272L14.6565 2.37619C14.2379 2.12713 13.6742 2.26576 13.4065 2.71171L13.2991 2.89732C12.7642 3.82013 11.958 4.44904 11.0012 4.44904C10.0439 4.44904 9.24021 3.81978 8.71021 2.89608C8.70992 2.89556 8.70962 2.89505 8.70933 2.89454L8.60347 2.71171ZM6.59248 1.08345C7.75191 0.39809 9.22257 0.818566 9.89455 1.94807L9.89911 1.95574L10.0091 2.14576L10.0107 2.14854C10.3807 2.794 10.7666 2.94904 11.0012 2.94904C11.237 2.94904 11.6259 2.79268 12.0009 2.14576C12.0009 2.14587 12.001 2.14565 12.0009 2.14576L12.1154 1.94804C12.7874 0.818533 14.2581 0.398086 15.4175 1.08346L17.1421 2.07036C18.4147 2.79757 18.8463 4.42866 18.1194 5.68675L18.1189 5.68764C17.7439 6.33451 17.8028 6.74773 17.9198 6.95082C18.0369 7.15402 18.3648 7.41154 19.11 7.41154C20.5616 7.41154 21.76 8.59476 21.76 10.0615V11.8215C21.76 13.2732 20.5768 14.4715 19.11 14.4715C18.3648 14.4715 18.0369 14.7291 17.9198 14.9323C17.8028 15.1354 17.7439 15.5486 18.1189 16.1954L18.1212 16.1994C18.8444 17.465 18.4157 19.0847 17.1425 19.8125C17.1424 19.8126 17.1426 19.8124 17.1425 19.8125L15.4174 20.7997C14.258 21.485 12.7874 21.0645 12.1154 19.935L12.1109 19.9273L12.0009 19.7373L11.9993 19.7345C11.6293 19.0891 11.2434 18.934 11.0087 18.934C10.773 18.934 10.3841 19.0904 10.0091 19.7373C10.009 19.7374 10.0091 19.7372 10.0091 19.7373L9.8946 19.935C9.22263 21.0645 7.75199 21.485 6.59257 20.7997L4.8679 19.8127C4.86776 19.8126 4.86803 19.8128 4.8679 19.8127C3.59558 19.0854 3.16378 17.4543 3.8906 16.1963L3.89112 16.1954C4.26605 15.5486 4.20721 15.1354 4.09018 14.9323C3.97308 14.7291 3.64521 14.4715 2.9 14.4715C1.43322 14.4715 0.25 13.2732 0.25 11.8215V10.0615C0.25 8.60989 1.43322 7.41154 2.9 7.41154C3.64521 7.41154 3.97308 7.15402 4.09018 6.95082C4.20721 6.74773 4.26605 6.33451 3.89112 5.68764L3.8906 5.68675C3.16378 4.42879 3.59518 2.79792 4.86749 2.07059L6.59248 1.08345Z"
                    fill={isMangementActive ? '#00ABFB' : '#272727'}
                  />
                </svg>
                <span className={style.menu_name}> Management</span>
              </div>
            </NavLink>
          </li>
        )}

        <div className={style.Submenu_sidebar}>
          {!isOrganizationUser && (
            <li>
              <NavLink className={({ isActive }) => ` ${isActive ? style.active : ''}`} to="/user-management">
                <div>
                  <div className={style.menu_item}>
                    <span className={` ${style.menu_name} ${style.submenu_span}`}>User List</span>
                  </div>
                </div>
              </NavLink>
            </li>
          )}
          {!isOrganizationAdmin && !isOrganizationUser && (
            <li>
              <NavLink className={({ isActive }) => ` ${isActive ? style.active : ''}`} to="/organization-management">
                <div>
                  <div className={style.menu_item}>
                    <span className={` ${style.menu_name} ${style.submenu_span}`}>Organization List</span>
                  </div>
                </div>
              </NavLink>
            </li>
          )}
          {!isOrganizationUser && (
            <li>
              <NavLink
                className={({ isActive }) => ` ${isActive || isMgtActive || isEditSubjectPipeLine ? style.active : ''}`}
                to="/masters"
              >
                <div>
                  <div className={style.menu_item}>
                    <span className={` ${style.menu_name} ${style.submenu_span}`}>Masters Template</span>
                  </div>
                </div>
              </NavLink>
            </li>
          )}
        </div>

        <li>
          <NavLink
            to="/reports-history"
            className={({ isActive }) =>
              `${style.menu_item_content} ${isActive || isViewReportDetailsActive ? style.active : ''}`
            }
          >
            <div className={style.menu_item}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  {pathsreport.map((path, index) => (
                    <path key={index + path} fillRule="evenodd" clipRule="evenodd" d={path} fill={iconColor} />
                  ))}
                </g>
              </svg>
              <span className={style.menu_name}>Report</span>
            </div>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/review"
            className={({ isActive }) => `${style.menu_item_content} ${isActive ? style.active : ''}`}
          >
            <div className={style.menu_item}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  {svgPathReview.map((path, index) => (
                    <path key={index + path.d} fillRule="evenodd" clipRule="evenodd" d={path.d} fill={path.fill} />
                  ))}
                </g>
              </svg>
              <span className={style.menu_name}>Review</span>
            </div>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default SideBarMenu;
